var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("img", { staticClass: "icon", attrs: { src: _vm.icon } }),
    _vm._v(" "),
    _c("h1", { staticClass: "account-verification__step__title title" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "step" }, [
        _vm._v(
          "\n      1. Guide the user through the instructions below.\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "step__list" },
        _vm._l(_vm.subSteps, function (subStep) {
          return _c("li", { key: subStep, staticClass: "step__item" }, [
            _vm._v("\n        " + _vm._s(subStep) + "\n      "),
          ])
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "account-verification__step__buttons-container" },
      [
        _c(
          "el-button",
          {
            staticClass:
              "account-verification__step__button account-verification__step__button-white",
            attrs: { plain: "", type: "primary" },
            on: { click: _vm.notifyBack },
          },
          [_vm._v("\n      " + _vm._s(_vm.backButtonText) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            staticClass: "account-verification__step__button",
            attrs: { type: "primary" },
            on: { click: _vm.notifyContinue },
          },
          [_vm._v("\n      " + _vm._s(_vm.processButtonText) + "\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "step" }, [
        _vm._v("\n      2. Proceed to the next screen.\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "final-step" }, [
        _vm._v(
          "\n      Once the customer generates their code, click Continue.\n    "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }